import React, { useEffect, useState } from "react";
import { getApiBaseUrl, authenticatedRequest } from './Utils.js'
import { useAuth } from "./AuthContext";
import HLSJS from "./HLS.js"

const OTMMViewer = (props) => {

  const authUser = useAuth();

  const [apiURL, setApiUrl] = useState(null);
  const [fileName, setFileName] = useState('');
  const [fileSize, setFileSize] = useState('');
  const [fileStreamable, setFileStreamable] = useState(false);
  const [exportStarted, setExportStarted] = useState(false);
  const [exportJobID, setExportJobID] = useState(null);
  const [exportComplete, setExportComplete] = useState(false);
  const [exportText, setStatusText] = useState("");
  const [downloadToken, setDownloadToken] = useState("");
  const [downloadURL, setDownloadURL] = useState("");
  const [fileError, setFileError] = useState(null);

  let path = window.location.pathname;
  path = path.replace("ui/", "");
  path = path.replace("otmmViewer/", "");
  let pathArray = path.split("/");
  let assetID = pathArray[1];
  let tcID = pathArray[2];
  let hash = pathArray[3];

  let showError = (!assetID || !tcID || !hash);

  useEffect(() => {
    if(authUser && authUser.access_token) {
      getApiBaseUrl(setApiUrl, authUser.access_token);
    }
  }, [authUser]);

  useEffect(() => {
    if (authUser && apiURL) {
      authenticatedRequest(`${apiURL}/ui/fileInfo/${assetID}`, authUser.access_token, (response) => {
        console.log(response);
        setFileName(response.fileName);
        setFileSize(response.fileSize);
        setFileStreamable(response.streamable);
      }, (response) => {
        setFileError(response);
      })
    }
  }, [apiURL, authUser]);

  useEffect(() => {
    if (!exportStarted || !authUser) return;
    const interval = setInterval(() => {
      const url = `${apiURL}/ui/isExportComplete/${exportJobID}`;
      authenticatedRequest(url, authUser.access_token, (response) => {
        console.log('Polling response data is ', response);
        if (response) {
          setExportComplete(true);
          setExportStarted(false);
          setStatusText("Export Complete");
        }
      }, (response) => {
        setStatusText("Error: " + response.statusText);
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [exportStarted, authUser, apiURL, exportJobID]);

  if (!authUser) {
    sessionStorage.setItem("app:redirect", location.href);
    window.location.replace('/');
    return null;
  }

  const startExport = () => {
    const url = `${apiURL}/exportOTMM/${assetID}/${tcID}/${hash}`;
    authenticatedRequest(url, authUser.access_token, (response) => {

      setStatusText("Export in progress");
      console.log('Export response data is ', response);
      setExportJobID(response.jobID);
      if (response.exportComplete) {
        setExportComplete(true);
        setStatusText("Export Complete");
      } else {
        setExportStarted(true);
      }
      setDownloadURL(response.downloadPath);
      setDownloadToken(response.token);
    }, (response) => {
      alert("Error: " + response.statusText);
    });
  }

  const startDownload = () => {
    setStatusText("");

    const url = `${apiURL}/ui/otmmDownload/${downloadToken}${downloadURL}`;
    console.log("Download URL: " + url);
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${authUser.access_token}`);

    fetch(url, {
      method: 'GET',
      headers: headers
    })
      .then((response) => response.blob())
      .then((blob) => {
        console.log(blob);
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          fileName,
        );

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      });
  }

  const isExpired = Math.round(Date.now() / 1000) > authUser.expires_at;

  return (
    <div>
      {
        showError ? "Error processing data" :
          (
            <div>
              <div className='text-center'>
                <h4>Hello, {authUser.profile.given_name}</h4>
                {isExpired &&
                  <p className="text-danger">Your authentication has expired. The video will stop buffering and export/download will not work. Please reload the page to continue.</p>
                }
                {
                  fileError ?
                    <p>Cannot retrieve media.  Please contact teamconnectsupport@bnsf.com for assistance. </p>
                    : <p>Filename: "{fileName}", file size: {fileSize}MB</p>
                }

                {
                  apiURL && fileStreamable ?
                    <HLSJS options={{ source: `${apiURL}/ui/stream/${assetID}/${tcID}/${hash}/playlist.m3u8` }} token={authUser.access_token} />
                    : fileStreamable ? "Error" : ""
                }

                <button className="btn btn-raised btn-primary" id="export" disabled={exportStarted} onClick={startExport}>Export</button>
                {exportText}
                <button className="btn btn-raised btn-primary" id="export" disabled={!exportComplete} onClick={startDownload}>Download</button>
              </div>
            </div>
          )
      }
    </div>
  )
}
export default OTMMViewer;
